import React from 'react';
import PropTypes from 'prop-types';
import { safeRest } from '@wds/utils';
import { SIZES, SEMANTIC_COLORS, TYPE_COLORS } from '@wds/helpers';
// import { DefaultStyles } from '@wds/styles';
import { useTheme } from 'react-jss';
import useStyles from '../useStyles';

// this pattern is described in React's documentation: https://reactjs.org/docs/higher-order-components.html#convention-wrap-the-display-name-for-easy-debugging
function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
}

function withIcon(Component) {
  function WithIcon({ color, title, size, ...rest }) {
    const theme = useTheme();
    const { wrenchIcons } = useStyles({ color, size, theme });

    return (
      <svg
        className={wrenchIcons}
        viewBox="0 0 16 16"
        preserveAspectRatio="xMidYMid"
        aria-label={title}
        role="img"
        {...safeRest(rest)}
      >
        <Component />
      </svg>
    );
  }

  WithIcon.displayName = `WithIcon(${getDisplayName(Component)})`;
  WithIcon.getOriginalComponent = () => Component;

  WithIcon.propTypes = {
    /**
     * Required prop for a11y
     */
    // eslint-disable-next-line consistent-return
    title: (props, propName) => {
      if (
        typeof props['aria-hidden'] === 'undefined' &&
        typeof props[propName] === 'undefined'
      ) {
        return new Error('title is required');
      }
    },
    /**
     * Different icon variant sizes
     */
    size: PropTypes.oneOf(SIZES.concat(['xl'])),
    /**
     * Color variants
     */
    color: PropTypes.oneOf(SEMANTIC_COLORS.concat(TYPE_COLORS)),
  };

  WithIcon.defaultProps = {
    title: undefined,
    color: undefined,
    size: undefined,
  };
  return WithIcon;
}

export default withIcon;
